import { BreedSchema } from "../types/breed";

export const ExpensiveBreedList: BreedSchema[] = [
    { id: '65', type: 'dog', breedName: 'Akita' },
    { id: '305', type: 'dog', breedName: 'American Bull Dog' },
    { id: '71', type: 'dog', breedName: 'Australian Dingo' },
    { id: '77', type: 'dog', breedName: 'Basenji' },
    { id: '82', type: 'dog', breedName: 'Basset Hound' },
    { id: '94', type: 'dog', breedName: 'Bernese Mountain Dog' },
    { id: '97', type: 'dog', breedName: 'Bloodhound' },
    { id: '103', type: 'dog', breedName: 'Bouvier Des Flandres' },
    { id: '104', type: 'dog', breedName: 'Boxer' },
    { id: '108', type: 'dog', breedName: 'Bull Terrier' },
    { id: '111', type: 'dog', breedName: 'Bulldog (Toy)' },
    { id: '110', type: 'dog', breedName: 'Bulldog (English)' },
    { id: '112', type: 'dog', breedName: 'Bullmastiff' },
    { id: '126', type: 'dog', breedName: 'Chow Chow' },
    { id: '133', type: 'dog', breedName: 'Continental Landseer' },
    { id: '134', type: 'dog', breedName: 'Coonhound' },
    { id: '149', type: 'dog', breedName: 'Dobermann' },
    { id: '150', type: 'dog', breedName: 'Dogue De Bordeaux' },
    { id: '154', type: 'dog', breedName: 'English Bull Terrier' },
    { id: '160', type: 'dog', breedName: 'Estrela Mountain Dog' },
    { id: '171', type: 'dog', breedName: 'French Bulldog' },
    { id: '176', type: 'dog', breedName: 'German Shepherd (Alsatian)' },
    { id: '184', type: 'dog', breedName: 'Giant Schnauzer' },
    { id: '192', type: 'dog', breedName: 'Greyhound' },
    { id: '190', type: 'dog', breedName: 'Great Dane' },
    { id: '202', type: 'dog', breedName: 'Irish Wolfhound' },
    { id: '319', type: 'dog', breedName: 'Kooikerhondje' },
    { id: '216', type: 'dog', breedName: 'Leonberger' },
    { id: '223', type: 'dog', breedName: 'Mastiff' },
    { id: '230', type: 'dog', breedName: 'Neapolitan Mastiff' },
    { id: '231', type: 'dog', breedName: 'Newfoundland' },
    { id: '245', type: 'dog', breedName: 'Poodle (Standard)' },
    { id: '247', type: 'dog', breedName: 'Pug' },
    { id: '334', type: 'dog', breedName: 'Pyrenean Mastiff' },
    { id: '248', type: 'dog', breedName: 'Pyrenean Mountain Dog' },
    { id: '255', type: 'dog', breedName: 'Rottweiler' },
    { id: '262', type: 'dog', breedName: 'Shar Pei' },
    { id: '289', type: 'dog', breedName: 'Tibetan Mastiff' },
]